import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Link,
  NavLink,
} from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  UncontrolledDropdown,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import NavBarStyles from "./Navbar.css";

/* eslint-disable import/no-webpack-loader-syntax */

import NavbarIcon from "-!svg-react-loader!../icons/navbar-icon.svg";

import CartIcon from "-!svg-react-loader!../icons/cart.svg";

import utilities from "./Utilities";
let Utilities = new utilities();

export default class NavbarMain extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.state = {
      isOpen: false,
      dropdownOpen: false,
      cartItemCount: 0,
      user: {},
      isDropdownOpen: false,
    };
  }

  toggleDropdown() {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  }

  toggleAdminDropdown() {
    this.setState((prevState) => ({
      isDropdownOpen: !prevState.isDropdownOpen,
    }));
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  hide() {
    this.setState({
      isOpen: false,
    });
  }

  logout = () => {
    window.globalVars.server.logout();
  };

  createCartItem = () => {
    window.location.href = "/build/size/" + Utilities.createCartItem();
  };

  componentDidMount() {
    let cartItemCount = 0;
    let cart = JSON.parse(localStorage.getItem("cart"));
    if (Utilities.isENU(cart)) {
      cart = [];
    }

    for (let i = 0; i < cart.length; i++) {
      let cartItem = JSON.parse(localStorage.getItem(cart[i]));

      if (!Utilities.isENU(cartItem) && cartItem.addeddToCart) {
        cartItemCount++;
      }
    }

    this.setState({
      cartItemCount: cartItemCount,
    });
  }

  render() {
    const { isOpen, dropdownOpen, cartItemCount } = this.state;
    let cartButtonMobile = "";
    let cartButton = "";

    cartButtonMobile = (
      <div className="cart mobile">
        <Link className="nav-link" to="/cart">
          <CartIcon />
          {this.state.cartItemCount > 0 ? (
            <label>{this.state.cartItemCount}</label>
          ) : null}
        </Link>
      </div>
    );

    cartButton = (
      <NavItem className="cart desktop">
        <Link className="nav-link" to="/cart">
          <CartIcon />
          {this.state.cartItemCount > 0 ? (
            <label>{this.state.cartItemCount}</label>
          ) : null}
        </Link>
      </NavItem>
    );

    return (
      <div className="navbar-container no-print" data-open={isOpen}>
        {this.props.loggedIn &&
        this.props.user !== null &&
        this.props.user.type < 3 ? (
          <label className="banner">Admin mode</label>
        ) : null}
        <div className="main-container">
          <Navbar light expand="md">
            <Link onClick={() => this.hide()} className="navbar-brand" to="/">
              <NavbarIcon />
            </Link>
            <NavbarToggler onClick={this.toggle} />
            {cartButtonMobile}
            <Collapse isOpen={isOpen} navbar>
              <Nav className="ml-auto" navbar>
                <Dropdown
                  nav
                  inNavbar
                  isOpen={dropdownOpen}
                  toggle={this.toggleDropdown}
                >
                  <DropdownToggle nav caret>
                    What We Do
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem>
                      <a
                        onClick={() => {
                          this.hide();
                          this.createCartItem();
                        }}
                        className="nav-link framing"
                        href="#"
                        activeClassName="active"
                        style={{ color: isOpen ? "#fcb34e" : null }}
                      >
                        Custom Framing
                      </a>
                    </DropdownItem>
                    <DropdownItem>
                      <NavLink
                        onClick={this.hide}
                        className="nav-link"
                        to="/canvas-stretching"
                        activeClassName="active"
                        style={{ color: isOpen ? "#fcb34e" : null }}
                      >
                        Canvas Stretching
                      </NavLink>
                    </DropdownItem>
                    <DropdownItem>
                      <NavLink
                        onClick={this.hide}
                        className="nav-link"
                        to="/art-printing"
                        activeClassName="active"
                        style={{ color: isOpen ? "#fcb34e" : null }}
                      >
                        Fine Art Printing
                      </NavLink>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
                <NavItem>
                  <NavLink
                    onClick={this.hide}
                    className="nav-link"
                    to="/about-us"
                    activeClassName="active"
                    style={{ color: isOpen ? "#fcb34e" : null }}
                  >
                    About Us
                  </NavLink>
                </NavItem>
                <NavItem>
                  <a
                    onClick={() => this.hide()}
                    className="nav-link"
                    href={
                      window.region === "SG"
                        ? "https://blog.frameit.com.sg/"
                        : "https://blog.frameit.my/"
                    }
                  >
                    Blog
                  </a>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={this.hide}
                    className="nav-link"
                    to="/contact-us"
                    activeClassName="active"
                    style={{ color: isOpen ? "#fcb34e" : null }}
                  >
                    Contact Us
                  </NavLink>
                </NavItem>
                {cartButton}
                {this.props.loggedIn ? (
                  <NavItem>
                    <Link
                      onClick={() => this.hide()}
                      className="nav-link"
                      to="/profile"
                    >
                      Profile
                    </Link>
                  </NavItem>
                ) : (
                  <NavItem>
                    <Link
                      onClick={() => this.hide()}
                      className="nav-link nav-link--auth"
                      to="/login"
                    >
                      Login / Register
                    </Link>
                  </NavItem>
                )}
                {this.props.loggedIn &&
                this.props.user !== null &&
                this.props.user.type < 3 ? (
                  <UncontrolledDropdown
                    nav
                    inNavbar
                    isOpen={this.state.isDropdownOpen}
                  >
                    <DropdownToggle
                      nav
                      caret
                      onClick={() => {
                        this.toggleAdminDropdown();
                      }}
                    >
                      Admin
                    </DropdownToggle>
                    <DropdownMenu right>
                      <Link
                        onClick={() => {
                          this.hide();
                          this.toggleAdminDropdown();
                        }}
                        className="nav-link"
                        to="/admin/customers"
                      >
                        Customers
                      </Link>
                      <Link
                        onClick={() => {
                          this.hide();
                          this.toggleAdminDropdown();
                        }}
                        className="nav-link"
                        to="/admin/orders"
                      >
                        Orders
                      </Link>
                      <Link
                        onClick={() => {
                          this.hide();
                          this.toggleAdminDropdown();
                        }}
                        className="nav-link"
                        to="/admin/main-settings"
                      >
                        Main settings
                      </Link>
                      <Link
                        onClick={() => {
                          this.hide();
                          this.toggleAdminDropdown();
                        }}
                        className="nav-link"
                        to="/admin/email"
                      >
                        Emails
                      </Link>
                      <Link
                        onClick={() => {
                          this.hide();
                          this.toggleAdminDropdown();
                        }}
                        className="nav-link"
                        to="/admin/hanging-components"
                      >
                        Hanging components
                      </Link>
                      <Link
                        onClick={() => {
                          this.hide();
                          this.toggleAdminDropdown();
                        }}
                        className="nav-link"
                        to="/admin/labor-costs"
                      >
                        Labor costs
                      </Link>
                      <Link
                        onClick={() => {
                          this.hide();
                          this.toggleAdminDropdown();
                        }}
                        className="nav-link"
                        to="/admin/other-costs"
                      >
                        Other costs
                      </Link>
                      <Link
                        onClick={() => {
                          this.hide();
                          this.toggleAdminDropdown();
                        }}
                        className="nav-link hide"
                        to="/admin/backings"
                      >
                        Backings
                      </Link>
                      <Link
                        onClick={() => {
                          this.hide();
                          this.toggleAdminDropdown();
                        }}
                        className="nav-link"
                        to="/admin/glazings"
                      >
                        Glazings
                      </Link>
                      <Link
                        onClick={() => {
                          this.hide();
                          this.toggleAdminDropdown();
                        }}
                        className="nav-link"
                        to="/admin/frames"
                      >
                        Frames
                      </Link>
                      <Link
                        onClick={() => {
                          this.hide();
                          this.toggleAdminDropdown();
                        }}
                        className="nav-link"
                        to="/admin/backings"
                      >
                        Backings
                      </Link>
                      <Link
                        onClick={() => {
                          this.hide();
                          this.toggleAdminDropdown();
                        }}
                        className="nav-link"
                        to="/admin/matte-suggestions"
                      >
                        Matte suggestions
                      </Link>
                      <Link
                        onClick={() => {
                          this.hide();
                          this.toggleAdminDropdown();
                        }}
                        className="nav-link"
                        to="/admin/matte-costs"
                      >
                        Matte costs
                      </Link>
                      <Link
                        onClick={() => {
                          this.hide();
                          this.toggleAdminDropdown();
                        }}
                        className="nav-link"
                        to="/admin/matte-colors"
                      >
                        Matte colours
                      </Link>
                      <Link
                        onClick={() => {
                          this.hide();
                          this.toggleAdminDropdown();
                        }}
                        className="nav-link"
                        to="/admin/popular-sizes"
                      >
                        Popular sizes
                      </Link>
                      <Link
                        onClick={() => {
                          this.hide();
                          this.toggleAdminDropdown();
                        }}
                        className="nav-link"
                        to="/admin/edit/home"
                      >
                        Edit Homepage
                      </Link>
                      <Link
                        onClick={() => {
                          this.hide();
                          this.toggleAdminDropdown();
                        }}
                        className="nav-link"
                        to="/admin/edit/cart"
                      >
                        Edit Cart
                      </Link>
                      <Link
                        onClick={() => {
                          this.hide();
                          this.toggleAdminDropdown();
                        }}
                        className="nav-link"
                        to="/admin/edit/checkout"
                      >
                        Edit Checkout
                      </Link>
                      <Link
                        onClick={() => {
                          this.hide();
                          this.toggleAdminDropdown();
                        }}
                        className="nav-link"
                        to="/admin/edit/about"
                      >
                        Edit About
                      </Link>
                      <Link
                        onClick={() => {
                          this.hide();
                          this.toggleAdminDropdown();
                        }}
                        className="nav-link"
                        to="/admin/edit/contact"
                      >
                        Edit Contact
                      </Link>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                ) : null}
              </Nav>
            </Collapse>
            {this.props.loggedIn ? (
              <button onClick={this.logout} className="log-out-btn">
                (<span>Log out</span>)
              </button>
            ) : null}
          </Navbar>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Navbar.js